module.exports = "<h3>Access denied</h3>"